<template>
  <div>
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <h4 class="mb-0 ml-50">
        Information
      </h4>
    </div>

    <!-- Form: Personal Info Form -->
    <b-form class="mt-1">
      <b-row>
        <!-- Field: Birth Date -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Birth Date" label-for="birth-date">
            <flat-pickr
              v-model="userData.birthDate"
              class="form-control"
              :config="{ dateFormat: 'd-m-Y' }"
              placeholder="DD-MM-YYYY"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Gender -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Gender" label-for="gender" label-class="mb-1">
            <b-form-radio-group
              id="gender"
              v-model="userData.gender"
              :options="genderOptions"
              value="male"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Language -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Languages" label-for="languages">
            <v-select
              v-model="userData.languages"
              multiple
              label="languages"
              :options="languageOptions"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Preferences -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Preferences" label-for="preferences" label-class="mb-1">
            <b-form-checkbox-group
              id="preferences"
              v-model="userData.preferences"
              :options="preferencesOptions"
              :reduce="val => val.value"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Permits -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Permits" label-for="permits">
            <v-select
              v-model="userData.permits"
              multiple
              label="permits"
              :options="permitsOptions"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Hoiwa PRO -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Hoiwa PRO">
            <b-form-checkbox
              id="hoiwa_pro"
              v-model="userData.isSubcontractor"
              :value="true"
              :unchecked-value="false"
            >{{ $t('subcontractor') }}</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Header: Personal Info -->
      <div class="d-flex mt-2">
        <feather-icon icon="MapPinIcon" size="19" />
        <h4 class="mb-0 ml-50">
          {{ this.$t('address') }}
        </h4>
      </div>

      <!-- Form: Personal Info Form -->
      <b-row class="mt-1">
        <!-- Field: Address Line 1 -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group :label="this.$t('address')" label-for="address-line-1">
            <b-form-input id="address-line-1" v-model="userData.address.streetAddress" />
          </b-form-group>
        </b-col>

        <!-- Field: Address Line 2 -->
        <!--<b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Address Line 2"
            label-for="address-line-2"
          >
            <b-form-input
              id="address-line-2"
              v-model="userData.address.add_line_2"
              placeholder=""
            />
          </b-form-group>
        </b-col>-->

        <!-- Field: Postcode -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Postcode" label-for="postcode">
            <b-form-input
              id="postcode"
              v-model="userData.address.postcode"
              type="number"
              placeholder="00000"
            />
          </b-form-group>
        </b-col>

        <!-- Field: City -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="City" label-for="city">
            <b-form-input id="city" v-model="userData.address.city" />
          </b-form-group>
        </b-col>

        <!-- Field: State -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="State" label-for="state">
            <b-form-input
              id="state"
              v-model="userData.address.state"
              style="text-transform: capitalize"
              placeholder="Uusimaa"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Country -->
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Country" label-for="country">
            <b-form-input id="country" v-model="userData.address.country" placeholder="Finland" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="saveChanges"
          >
            {{ this.$t('save_changes') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            type="reset"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            :to="{ name: 'apps-personels-list' }"
          >
            {{ this.$t('close') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BButton,
  BFormCheckbox,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import i18n from '@hw-core/libs/i18n'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    saveChanges() {
      this.$emit('onSaveChanges')
    },
  },
  setup() {
    const userDataInfo = ref({
      dob: null,
      mobile: '+6595895857',
      website: 'https://rowboat.com/insititious/Angelo',
      language: 'French',
      gender: 'female',
      birthDate: '28-07-1998',
      contactOptions: ['Email', 'Message'],
      addressLine1: 'A-65, Belvedere Streets',
      addressLine2: '',
      postcode: '',
      city: 'New York',
      state: '',
      country: '',
    })

    const languageOptions = [
      'Finnish',
      'Somali',
      'English',
      'Spanish',
      'French',
      'Russian',
      'German',
      'Arabic',
    ]

    const genderOptions = [
      { text: i18n.t('male'), value: 'male' },
      { text: i18n.t('female'), value: 'female' },
    ]

    const preferencesOptions = [
      {text: i18n.t('work_preference.night_shifts'), value: 'yö-työ'},
      {text: i18n.t('work_preference.on_weekends'), value: 'viikonloppuisin'},
      {text: i18n.t('work_preference.on_holidays'), value: 'pyhinä'},
      {text: i18n.t('work_preference.on_weekdays'), value: 'arkisin'},
      {text: i18n.t('work_preference.home_care'), value: 'koti-hoito'},
      {text: i18n.t('work_preference.day_shifts'), value: 'päivä-työ'},
      {text: i18n.t('work_preference.only_nursing_work'), value: 'vain sairaanhoitaja työ'},
      {text: i18n.t('work_preference.evening_shifts'), value: 'ilta-työ'},
    ]

    const permitsOptions = ['love', 'rokotus lupa']
    return {
      userDataInfo,
      languageOptions,
      genderOptions,
      preferencesOptions,
      permitsOptions,
    }
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
</style>
